import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

export const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
  size = 'lg',
}) => {
  const sizes = {
    sm: 'max-w-3xl',
    md: 'max-w-4xl',
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    full: 'max-w-none',
  };

  return (
    <div className={`w-full px-4 md:px-8 lg:px-10 xl:px-12 ${sizes[size]} mx-auto ${className}`}>
      {children}
    </div>
  );
};

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}

export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  id,
  dark = false,
}) => {
  return (
    <section
      id={id}
      className={`
        w-full py-16 md:py-20 lg:py-24
        ${dark ? 'bg-bg-secondary' : 'bg-bg-primary'}
        ${className}
      `}
    >
      {children}
    </section>
  );
};

export default Container;
